class Itinerary {
    constructor(element) {
        try{
            this.itinContent = element.querySelector(".sd-itin-body");
            this.scrollBar = element.querySelector('.progress-bar');
            this.itinContent.addEventListener("scroll",(e)=>{
                var winScroll = e.target.scrollTop || e.target.scrollTop;
                var height = e.target.scrollHeight - e.target.clientHeight;
                var scrolled = (winScroll / height) * 100;             
               this.scrollBar.style.width = scrolled + "%";
            });        
        } catch (error) {
            console.log(error);
        }
    }
}

export default Itinerary;